import { QueryConfigProvider } from 'core/api/query.provider';
import { AuthProvider } from 'core/auth/auth.context';
import { OidcAuthProvider } from 'core/auth/oidc-auth.provider';
import { i18n } from 'core/i18n';
import { LocalizationProvider } from 'core/localization';
import { GlobalStyleProvider } from 'core/theme';
import { StartupConnectivityGuard } from 'layout/startup-connectivity-guard';
import React from 'react';
import { I18nextProvider } from 'react-i18next';

interface AppProvidersProps {
  children: JSX.Element | JSX.Element[] | string;
}

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => (
  <GlobalStyleProvider>
    <StartupConnectivityGuard>
      <OidcAuthProvider>
        <AuthProvider>
          <QueryConfigProvider>
            <I18nextProvider i18n={i18n}>
              <LocalizationProvider>{children}</LocalizationProvider>
            </I18nextProvider>
          </QueryConfigProvider>
        </AuthProvider>
      </OidcAuthProvider>
    </StartupConnectivityGuard>
  </GlobalStyleProvider>
);
